export default __webpack_public_path__ + "static/media/app-in-hand.e17ff0ac.png";